export const blockIconsHardwareKeyboardArrowUpNew = (
	<span className='material-symbols-outlined'>keyboard_arrow_up</span>
);
